export default __webpack_public_path__ + "static/media/PREP.c8b8bf45.svg";